<div class="body" *transloco="let t">
  <div class="type-header">
    <div class="head-type">{{ t('AUDIT-SETUP-PAGE.TYPE-VIEW.HEADER.TITLE') }}</div>
    <div class="small-head-type">{{ t('AUDIT-SETUP-PAGE.TYPE-VIEW.HEADER.SUBTITLE') }}</div>
  </div>
  <div class="button-container">
    <button [class.click_5S]="selectedType === auditType.FiveS" class="four-button" (click)="selectType(auditType.FiveS)">
      <img src="/assets/5s2.svg" alt="5S">
      <div class="body-emphasized">{{ t('AUDIT-SETUP-PAGE.TYPE-VIEW.AUDIT-TYPES.FIVES-TITLE') }}</div>
      <div class="description" [innerHTML]="t('AUDIT-SETUP-PAGE.TYPE-VIEW.AUDIT-TYPES.FIVES-DESC-HTML')"></div>
    </button>
    <div class="hide_other_audits_temp">
      <button [class.click_EHS]="selectedType === auditType.Ehs" class="four-button" (click)="selectType(auditType.Ehs)">
        <img src="/assets/ehs.svg" alt="EHS">
        <div class="body-emphasized">{{ t('AUDIT-SETUP-PAGE.TYPE-VIEW.AUDIT-TYPES.EHS-TITLE') }}</div>
        <div class="description" [innerHTML]="t('AUDIT-SETUP-PAGE.TYPE-VIEW.AUDIT-TYPES.EHS-DESC-HTML')"></div>
      </button>
      <button [class.click_QMM]="selectedType === auditType.Qmm" class="four-button" (click)="selectType(auditType.Qmm)">
        <img src="/assets/qmm.svg" alt="QMM">
        <div class="body-emphasized">{{ t('AUDIT-SETUP-PAGE.TYPE-VIEW.AUDIT-TYPES.QMM-TITLE') }}</div>
        <div class="description" [innerHTML]="t('AUDIT-SETUP-PAGE.TYPE-VIEW.AUDIT-TYPES.QMM-DESC-HTML')"></div>
      </button>
      <button [class.click_ES]="selectedType === auditType.Es" class="four-button" (click)="selectType(auditType.Es)">
        <img src="/assets/es.svg" alt="ES">
        <div class="body-emphasized">{{ t('AUDIT-SETUP-PAGE.TYPE-VIEW.AUDIT-TYPES.ES-TITLE') }}</div>
        <div class="description" [innerHTML]="t('AUDIT-SETUP-PAGE.TYPE-VIEW.AUDIT-TYPES.ES-DESC-HTML')"></div>
      </button>
    </div>
  </div>
  <div *ngIf="showErrorMessage && !isValid" class="error">
    <img src="/assets/warning.png" alt="Warning">
    <p>{{ t('VALIDATION.ERROR-MSG') }}</p>
  </div>
</div>
